<template>
    <div v-html="content_section">

        <!-- section class="home_banner_area">
        
            <div class="banner_inner">
                
                <div class="container">
                    
                    
                    <div class="row">
                        
                        <div class="col-lg-8">
                            <div class="banner_content">
                                <h2>Projetos personalizados <br />de alta qualidade <br />compromissados com a sustentabilidade</h2>
                                <p>Quer saber por que oferecemos a melhor solu&ccedil;&atilde;o para o seu neg&oacute;cio?</p>
                                <a class="banner_btn" href="/#dlealp_section_about">Conhe&ccedil;a a Dlealp!</a></div>
                        </div>
                        
                        <div class="col-lg-4">
                            <div class="home_right_box">
                                <div class="home_item"><a href="/galeria/Hospitalar"><i class="flaticon-medicine"></i><br><span>HOSPITALAR</span></a></div>
                                <div class="home_item"><a href="/galeria/Hotelaria"><i class="flaticon-hotel"></i><br><span>HOTELARIA</span></a></div>
                                <div class="home_item"><a href="/galeria/Comerciais e Governamentais"><i class="flaticon-monument"></i><br><span>GOVERNO E COMÉRCIO</span></a></div>
                                <div class="home_item"><a href="/galeria/Divisórias"><i class="flaticon-wall"></i><br><span>DIVISÓRIAS</span></a></div>
                                <div class="home_item"><a href="/galeria/Interiores"><i class="flaticon-interior"></i><br><span>INTERIORES</span></a></div>
                                <div class="home_item"><a href="/galeria/Portas"><i class="flaticon-door"></i><br><span>PORTAS</span></a></div>
                            </div>
                        </div>

                    </div>


                </div>

            </div>


        </section !-->
    </div>
</template>

<script>
    export default {
        name: 'Banner',
        props: {
            content_section: String,
        },
    }
</script>

<style>

</style>